import React from 'react';
import PropTypes from 'prop-types';
import { AJAXOptionButton } from '../elements-buttons/ajax-option-button';
import { Tooltip } from '../elements-tooltip/tooltip-v2';
import { NotificationTooltip } from '../elements-tooltip/notification-tooltip';
import { updateExperience } from '../app-main/actions/nux';
import { getUserExperiences } from '../../../assets/js/nux';
import { INBOX_CTA_TITLES } from './data/inbox-cta-data';
import { FormattedMessage } from 'react-intl';
import { intlInboxCTAs } from './data/intl-booking-status-data';

export class InboxCTA extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      inviteToBookExperienceId: '',
      showInviteToBookToolTip: false
    };

    this.nuxCtaAction = this.nuxCtaAction.bind(this);
    this.updateAddOnsNux = this.updateAddOnsNux.bind(this);
  }

  componentDidMount () {
    const { title, accessToken, isHost } = this.props;
    if (_.includes([INBOX_CTA_TITLES.CREATE_CUSTOM_OFFER], title) && isHost) {
      getUserExperiences('name=invite-to-book-tooltip', accessToken, (res) => {
        const showInviteToBookToolTip = _.some(res.data, { name: 'invite-to-book-tooltip' });
        const inviteToBookExperienceId = _.get(_.filter(res.data, { name: 'invite-to-book-tooltip' }), ['0', '_id']);
        if (showInviteToBookToolTip) {
          this.setState({
            inviteToBookExperienceId,
            showInviteToBookToolTip
          });
        }
      });
    }
  }

  nuxCtaAction () {
    this.updateAddOnsNux();
    this.props.ctaAction();
  }

  updateAddOnsNux () {
    const { dispatch } = this.props;
    const { inviteToBookExperienceId } = this.state;
    dispatch(updateExperience(inviteToBookExperienceId));
  }

  render () {
    const { title, primaryButton, ctaAction, ctaCallback, id, iosWebView } = this.props;
    const { showInviteToBookToolTip } = this.state;
    return (
      showInviteToBookToolTip && !iosWebView ?
        <li className="v-center">
          <NotificationTooltip
            show={showInviteToBookToolTip}
            placement="right"
            anchor={<AJAXOptionButton
              clickAction={ this.nuxCtaAction }
              buttonClass={`btn classic ${primaryButton ? 'btn-primary' : 'btn-default'}`}
              buttonText={ <FormattedMessage { ...intlInboxCTAs[title] } /> }
              spinnerColor={ primaryButton ? '' : '#6A707A' }
              id={id}
            />}
            anchorClickCB={this.updateAddOnsNux}
            exitCB={this.updateAddOnsNux}
            title={<FormattedMessage id="inbox.inbox_cta.tooltip_invite_to_book_title" defaultMessage="Invite to Book" />}
            arrowPlacement={{ arrowTop: 100 }}
          >
            <FormattedMessage
              id="inbox.inbox_cta.tooltip_invite_to_book_nux_text"
              defaultMessage="Make it easier for your guest to book by pre-approving their inquiry."
            />
          </NotificationTooltip>
        </li> :
        <li className="v-center">
          <AJAXOptionButton
            clickAction={ ctaAction }
            buttonClass={`btn classic ${primaryButton ? 'btn-primary' : 'btn-default'}`}
            buttonText={ <FormattedMessage { ...intlInboxCTAs[title] } /> }
            clickCallback={ ctaCallback }
            spinnerColor={ primaryButton ? '' : '#6A707A' }
            id={id}
          />
        </li>
    );
  }
}

InboxCTA.propTypes = {
  title: PropTypes.string,
  primaryButton: PropTypes.bool,
  ctaAction: PropTypes.func,
  ctaCallback: PropTypes.func,
  id: PropTypes.string,
  accessToken: PropTypes.string,
  isHost: PropTypes.bool,
  dispatch: PropTypes.func,
  iosWebView: PropTypes.bool
};
